// extracted by mini-css-extract-plugin
module.exports = {"defaultLogoSize":"nerdwallet-taxes_defaultLogoSize__vtEMf","desktopSmallSize":"nerdwallet-taxes_desktopSmallSize__U_DIr"};